import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { StyledLabel, StyledInput, styledSystemKeys } from "./viewButton.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ViewButton = function ViewButton(props) {
  var id = props.id,
    label = props.label,
    _props$hideLabel = props.hideLabel,
    hideLabel = _props$hideLabel === void 0 ? true : _props$hideLabel,
    icon = props.icon,
    checked = props.checked,
    name = props.name,
    disabled = props.disabled,
    onChange = props.onChange,
    className = props.className;
  var labelText = !hideLabel ? label : "";
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledInput, _objectSpread({
      id: id,
      type: "radio",
      name: name,
      "aria-label": label,
      checked: checked,
      icon: icon,
      className: className,
      disabled: disabled,
      onChange: onChange
    }, extendedSystemStylesProps(styledSystemKeys, props))), /*#__PURE__*/_jsx(StyledLabel, {
      icon: icon,
      checked: checked,
      disabled: disabled,
      htmlFor: id,
      children: labelText
    })]
  });
};
ViewButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default ViewButton;